import React, { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FirebaseContext } from "../FirebaseProvider/FirebaseProvider";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import useUserAppData from "../../hooks/users/useUserAppData";
import useUserSecureAppData from "../../hooks/users/useUserSecureAppData";

// Create a new context for the authentication provider
export const AuthenticationContext = createContext({
  appUserId: null,
  user: null,
  userDetails: null,
  isCoach: false,
  isJanus: false,
  isLogged: false,
  loading: true,
  logOutUser: () => {},
});

// Create the authentication provider component
const AuthenticationProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLogged, setIsLogged] = useState(false);
  const [loading, setLoading] = useState(true);
  const { firebaseApp } = useContext(FirebaseContext);
  const { data: userDetails, isLoading } = useUserAppData(user?.uid);
  const { data: userSecureDetails, isSecureLoading } = useUserSecureAppData(
    user?.uid,
  );
  const [isRegistered, setIsRegistered] = useState();

  // Expiry/unpaid alerts (medical certificate, membership, subscription) used to
  // be shown here as toasts. They are now consolidated into the single
  // `/user-alerts` source surfaced by <AlertsList/> on the Home page.

  useEffect(() => {
    // Get the current user
    const auth = getAuth(firebaseApp);
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      console.log("Authentication state changed aaaaaa:", user);
      if (isRegistered === undefined || isRegistered === true) {
        setUser(user);
        setIsLogged(!!user);
        setLoading(false);
      }

      if (!user) {
        setIsRegistered(false);
      } else if (user && isRegistered === undefined) {
        setIsRegistered(true);
        setUser(user);
        setIsLogged(!!user);
        setLoading(false);
      }
    });
    return unsubscribe;
  }, [firebaseApp, isRegistered]);

  const logOutUser = async () => {
    const auth = getAuth(firebaseApp);
    await auth.signOut();
    // clear all session storage and local storage
    window.sessionStorage.clear();
    window.localStorage.clear();
    // reload and redirect to home page
    window.location.href = "/";
  };

  const isCoach = userSecureDetails?.roles?.includes("coach");
  // check if array tags contains at leas one element of the array

  const appUserId = userDetails?.id;
  console.log("App user ID aaaaaaaaa:", appUserId);
  // Render the children only when the authentication state is loaded
  return (
    <AuthenticationContext.Provider
      value={{
        isLogged,
        isCoach,
        user,
        appUserId,
        userDetails,
        loading,
        logOutUser,
      }}
    >
      {!loading && !isLoading && !isSecureLoading && children}
    </AuthenticationContext.Provider>
  );
};

AuthenticationProvider.displayName = "AuthenticationProvider";

AuthenticationProvider.propTypes = {
  children: PropTypes.node,
};

export default AuthenticationProvider;
